import gsap from "gsap";
import Slider from "./slider";
class Grid {
  constructor() {
    this.init();
  }

  init() {
    const autoplayTime = 2000;
    new Slider('.grid-card-slider', autoplayTime)
    const accordionButtons = document.querySelectorAll('.js-accordion-button');
    if (accordionButtons && window.innerWidth <= 768) {
      accordionButtons.forEach(button => {
        button.addEventListener('click', () => {
  
          const accordionContent = button.closest('.js-accordion');

          if (accordionContent) {
            if (accordionContent.offsetHeight == 50) {
              // gsap.to('.js-accordion', {
              //   height: 50,
              //   duration: 0.3,
              //   ease: 'power1.out'
              // });
      
              gsap.to(accordionContent, {
                height: 'auto',
                duration: 0.3,
                ease: 'power1.out'
              });
             
            } else {
              gsap.to(accordionContent, {
                height: 50,
                duration: 0.3,
                ease: 'power1.out'
              });
            }
          }
        });
      });
    }
  }

}

export default Grid;